import TweetCard, { getTweetIdFromUrl } from './view';

export { getTweetIdFromUrl };
export default TweetCard;
